/* ORIBA REVIVAL FESTIVAL — shared script for rf-* sections (Shopify theme + HTML preview).
 * No secrets live here. Reads only: the aggregated public snapshot JSON, and the
 * shopper's own data through the Shopify App Proxy (same origin).
 */
(function () {
  'use strict';
  var root = document.documentElement;
  if (root.hasAttribute('data-rf-init')) return;
  root.setAttribute('data-rf-init', '');
  // HTML preview hooks are honoured only on the preview page (<html data-rf-preview>)
  var PV = root.hasAttribute('data-rf-preview') ? window : {};

  /* ---------------- helpers ---------------- */
  var qs = function (s, el) { return (el || document).querySelector(s); };
  var qsa = function (s, el) { return Array.prototype.slice.call((el || document).querySelectorAll(s)); };
  var esc = function (v) {
    return String(v == null ? '' : v).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  };
  var readJSON = function (id) {
    var el = document.getElementById(id);
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  };
  var num = function (n) { return Math.round(Number(n) || 0).toLocaleString('ja-JP'); };
  var isNum = function (n) { return typeof n === 'number' && isFinite(n); };
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var JST = 9 * 3600 * 1000;
  var DOW = ['日', '月', '火', '水', '木', '金', '土'];
  var jstParts = function (ms) {
    var d = new Date(ms + JST);
    return { y: d.getUTCFullYear(), m: d.getUTCMonth() + 1, d: d.getUTCDate(), dow: d.getUTCDay(), h: d.getUTCHours(), mi: d.getUTCMinutes() };
  };
  var pad = function (n) { return (n < 10 ? '0' : '') + n; };
  var jstDateKey = function (ms) { var p = jstParts(ms); return p.y + '-' + pad(p.m) + '-' + pad(p.d); };
  var parseJst = function (date, time) {
    if (!date) return NaN;
    var t = time && /^\d{1,2}:\d{2}$/.test(time) ? (time.length === 4 ? '0' + time : time) : '00:00';
    return Date.parse(date + 'T' + t + ':00+09:00');
  };
  var parseDateTime = function (s) {
    if (!s) return NaN;
    var t = Date.parse(s);
    if (!isNaN(t)) return t;
    var m = String(s).match(/^(\d{4})[\/-](\d{1,2})[\/-](\d{1,2})(?:[ T](\d{1,2}):(\d{2}))?/);
    if (!m) return NaN;
    return parseJst(m[1] + '-' + pad(+m[2]) + '-' + pad(+m[3]), m[4] ? pad(+m[4]) + ':' + m[5] : '00:00');
  };
  var dateLabel = function (key) {
    var t = parseJst(key, '12:00');
    if (isNaN(t)) return key;
    var p = jstParts(t);
    return p.m + '月' + p.d + '日（' + DOW[p.dow] + '）';
  };
  var countUp = function (el, to) {
    if (!el) return;
    var from = Number(el.getAttribute('data-val')) || 0;
    el.setAttribute('data-val', to);
    if (reduceMotion || from === to) { el.textContent = num(to); return; }
    var start = null, dur = 1200;
    var step = function (ts) {
      if (!start) start = ts;
      var k = Math.min(1, (ts - start) / dur), e = 1 - Math.pow(1 - k, 3);
      el.textContent = num(from + (to - from) * e);
      if (k < 1) requestAnimationFrame(step);
    };
    requestAnimationFrame(step);
  };
  var every = function (ms, fn) { fn(); return setInterval(function () { if (!document.hidden) fn(); }, ms); };
  var ICON = {
    crown: '<svg class="rf-ic" viewBox="0 0 24 24" aria-hidden="true"><path d="M3 8l4.5 4L12 5l4.5 7L21 8l-2 10H5L3 8z" fill="currentColor"/><circle cx="12" cy="14" r="1.6" fill="#fff" opacity=".7"/></svg>',
    arrow: '<svg class="rf-ic rf-ic--arrow" viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12h13m-5-5l5 5-5 5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>'
  };

  /* ---------------- shared state ---------------- */
  var config = readJSON('rf-config') || {};
  var colors = readJSON('rf-colors') || {};
  var colorOf = function (key) { return colors[key] || { name: key, cat: '', catLabel: '', img: '', url: '', color: '' }; };
  var thumb = function (c, style) {
    return '<span class="rf-thumb' + (c.cat === 'furoshiki' ? ' rf-cat-furoshiki' : '') + '"' + (style ? ' style="' + style + '"' : '') + '>' + (c.img ? '<img src="' + esc(c.img) + '" alt="" loading="lazy" width="200" height="200">' : '') + '</span>';
  };
  var fullName = function (c) { return esc(c.name) + (c.catLabel ? '<span>（' + esc(c.catLabel) + '）</span>' : ''); };

  /* ---------------- snapshot (public aggregated data) ---------------- */
  var listeners = [], lastSnap = null;
  var onSnapshot = function (fn) { listeners.push(fn); if (lastSnap) fn(lastSnap); };
  var emit = function (snap) {
    lastSnap = snap;
    listeners.forEach(function (fn) { try { fn(snap); } catch (e) { if (window.console) console.warn('[rf]', e); } });
  };

  /* Sample data: shown only in the theme editor (design mode) or the HTML preview. */
  var demoSnapshot = function () {
    if (PV.RF_PREVIEW_SNAPSHOT) return PV.RF_PREVIEW_SNAPSHOT;
    var keys = Object.keys(colors);
    var rank = function (cat) {
      return keys.filter(function (k) { return !cat || colors[k].cat === cat; })
        .map(function (k, i) { return { key: k, units: Math.max(40, 782 - i * 61), prev_rank: i + 1 }; });
    };
    var feed = keys.slice(0, 6).map(function (k, i) { return { minutes_ago: 3 + i * 5, items: [{ key: k, qty: 1 }] }; });
    var combos = [];
    for (var j = 0; j + 1 < keys.length && combos.length < 3; j += 2) combos.push({ keys: [keys[j], keys[j + 1]], buyers: 84 - combos.length * 12 });
    return { demo: true, updated_at: new Date().toISOString(), totals: { sales: 48327650, units: 7824, participants: 3642 },
      ranking: { all: rank(''), eco: rank('eco'), furoshiki: rank('furoshiki') }, combos: combos, feed: feed };
  };
  /* A snapshot is used only if every headline number is a real, non-negative number.
     Anything else (error body, 404 not_ready, partial JSON) counts as a failed refresh. */
  var okNum = function (n) { return isNum(n) && n >= 0; };
  var validSnap = function (s) {
    return !!(s && typeof s === 'object' && s.totals && typeof s.totals === 'object' &&
      okNum(s.totals.sales) && okNum(s.totals.units) && okNum(s.totals.participants));
  };
  /* status: 'loading' (nothing yet) | 'ok' | 'stale' (last refresh failed, showing last good values) | 'error' (never got data) */
  var statusListeners = [], status = { state: 'loading', lastOkAt: 0 };
  var onStatus = function (fn) { statusListeners.push(fn); fn(status); };
  var setStatus = function (state) {
    status = { state: state, lastOkAt: status.lastOkAt };
    statusListeners.forEach(function (fn) { try { fn(status); } catch (e) {} });
  };
  var startSnapshot = function () {
    if (config.demo) { status.lastOkAt = Date.now(); setStatus('ok'); emit(demoSnapshot()); return; }
    if (!config.snapshotUrl) { setStatus('off'); return; }
    /* The API recomputes once a minute and is cached ~30 s (Cache-Control max-age=30 + 15 s edge memo),
       so polling faster than 60 s only returns the same numbers. Minimum 30 s, default 60 s,
       paused while the tab is hidden, exponential back-off (max 5 min) after failures. */
    var refresh = Math.max(30, Number(config.refresh) || 60) * 1000, MAX = 300000;
    var fails = 0, busy = false, timer = null, nextAt = 0;
    var schedule = function (ms) {
      clearTimeout(timer); nextAt = Date.now() + ms;
      timer = setTimeout(function () { if (document.hidden) return; load(); }, ms);
    };
    var load = function () {
      if (busy) return;
      busy = true;
      fetch(config.snapshotUrl, { credentials: 'omit', headers: { Accept: 'application/json' } })
        .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
        .then(function (s) {
          if (!validSnap(s)) throw new Error('invalid snapshot');
          fails = 0; status.lastOkAt = Date.now(); setStatus('ok'); emit(s);
        })
        .catch(function (e) {
          fails++;
          if (window.console) console.warn('[rf] snapshot', e && e.message);
          setStatus(lastSnap ? 'stale' : 'error');   // keep the last good numbers; never show 0 as if it were real
        })
        .then(function () {
          busy = false;
          schedule(fails ? Math.min(MAX, refresh * Math.pow(2, fails - 1)) : refresh);
        });
    };
    load();
    document.addEventListener('visibilitychange', function () { if (!document.hidden && Date.now() >= nextAt) load(); });
  };
  var updatedText = function (snap) {
    if (!snap || !snap.updated_at) return '';
    var t = Date.parse(snap.updated_at);
    if (isNaN(t)) return '';
    var p = jstParts(t);
    return (snap.demo ? '【サンプル表示】 ' : '') + p.m + '/' + p.d + ' ' + pad(p.h) + ':' + pad(p.mi) + ' 更新';
  };
  var reveal = function (section, has) { if (section.getAttribute('data-hide-empty') === 'true') section.hidden = !has; };

  /* ---------------- personal data via App Proxy (same origin) ---------------- */
  var withEvent = function (u) { return config.eventId ? u + (u.indexOf('?') < 0 ? '?' : '&') + 'event=' + encodeURIComponent(config.eventId) : u; };
  var mePromise = null;
  var fetchMe = function (url) {
    url = withEvent(url);
    if (PV.RF_PREVIEW_ME) return Promise.resolve(PV.RF_PREVIEW_ME);
    if (!mePromise) {
      mePromise = fetch(url, { credentials: 'same-origin', headers: { Accept: 'application/json', 'X-RF-Requested': '1' } })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); });
    }
    return mePromise;
  };

  /* ================= ② RECORD — stretch goals ================= */
  /* Goals come from the section's "ストレッチゴール" blocks (theme editor); built-in defaults only when there
     are none. Each goal is { amount, reward } — reward (title / text / image) is for later.
     Secrecy: goals not reached yet never get a DOM element or readable text; only the FIRST GOAL, the goals
     already reached and the one being challenged now are shown. The amounts reach this script encoded, so
     they are not readable in the page — but anything sent to the browser can be decoded by a determined
     visitor. Rewards for goals not reached yet must therefore NOT be put into the page at all: add them
     later either behind a per-goal "公開" switch in the theme editor or from a server (API) that returns
     only unlocked rewards. */
  var DEFAULT_GOALS = [10000000, 50000000, 100000000, 150000000, 200000000];
  var normalizeGoals = function (list) {
    var seen = {}, out = [];
    (list || []).forEach(function (g) {
      var amt = Math.round(Number(g && typeof g === 'object' ? g.amount : g));
      if (!isFinite(amt) || amt <= 0 || seen[amt]) return;
      seen[amt] = true;
      out.push({ amount: amt, reward: (g && g.reward) || null });
    });
    return out.sort(function (a, b) { return a.amount - b.amount; });
  };
  /* rate     = sales ÷ FIRST GOAL (the smallest goal) × 100 — not capped (200,000,000 / 10,000,000 → 2,000%)
     progress = sales ÷ the goal being challenged now × 100 (bar only; 100 once everything is reached)
     A goal counts as reached when sales ≥ amount; the next goal is revealed at that moment. */
  var stretchGoal = function (sales, goalList) {
    var goals = normalizeGoals(goalList && goalList.length ? goalList : DEFAULT_GOALS);
    var s = okNum(sales) ? sales : 0, reached = 0;
    while (reached < goals.length && s >= goals[reached].amount) reached++;
    var complete = reached === goals.length, base = goals[0].amount;
    var next = complete ? null : goals[reached];
    return {
      sales: s, base: base, rate: s / base * 100,
      cleared: goals.slice(0, reached).map(function (g, i) { return { index: i + 1, amount: g.amount, reward: g.reward }; }),
      next: next ? { index: reached + 1, amount: next.amount, first: reached === 0 } : null,
      progress: next ? Math.min(100, s / next.amount * 100) : 100,
      complete: complete
    };
  };
  var decodeGoal = function (code) {
    try { var t = atob(String(code)); return t.indexOf('rf:') === 0 ? Number(t.slice(3).split('').reverse().join('')) : NaN; } catch (e) { return NaN; }
  };
  var readGoals = function (sec) {
    var el = qs('[data-rf-goal-codes]', sec), codes = [];
    try { codes = JSON.parse(el ? el.textContent : '[]') || []; } catch (e) { codes = []; }
    return codes.map(decodeGoal);
  };
  var pctText = function (v) { return (Math.floor(v * 10 + 1e-9) / 10).toLocaleString('ja-JP', { minimumFractionDigits: 1, maximumFractionDigits: 1 }) + '%'; };
  window.ORIBA_RF = window.ORIBA_RF || {};
  window.ORIBA_RF.stretchGoal = stretchGoal;

  var initRecord = function (sec) {
    var startAt = parseDateTime(config.startAt), endAt = parseDateTime(config.endAt);
    var goals = normalizeGoals(readGoals(sec)); if (!goals.length) goals = normalizeGoals(DEFAULT_GOALS);
    var lastCleared = null;
    var cdLabel = qs('[data-rf-cd-label]', sec), cd = qs('[data-rf-cd]', sec);
    every(1000, function () {
      if (!cd) return;
      var now = PV.RF_PREVIEW_NOW || Date.now(), target, label;
      if (!isNaN(startAt) && now < startAt) { target = startAt; label = sec.getAttribute('data-label-before') || '開幕まで'; }
      else if (!isNaN(endAt) && now < endAt) { target = endAt; label = sec.getAttribute('data-label-during') || '終了まで'; }
      else if (!isNaN(endAt)) { cd.textContent = sec.getAttribute('data-text-ended') || '終了しました'; return; }
      else return;
      var s = Math.max(0, Math.floor((target - now) / 1000));
      var dd = Math.floor(s / 86400), hh = Math.floor(s % 86400 / 3600), mm = Math.floor(s % 3600 / 60), ss = s % 60;
      if (cdLabel) cdLabel.textContent = label;
      cd.innerHTML = dd + '<small>日</small><span class="rf-cd__time">' + pad(hh) + ':' + pad(mm) + ':' + pad(ss) + '</span>';
    });
    var statusEl = qs('[data-rf-status]', sec), upEl = qs('[data-rf-updated]', sec);
    onStatus(function (st) {
      if (st.state === 'off') return;
      sec.setAttribute('data-state', st.state);
      var key = { loading: 'data-text-loading', error: 'data-text-error', stale: 'data-text-stale' }[st.state];
      if (statusEl) statusEl.textContent = key ? (sec.getAttribute(key) || '') : '';
    });
    var yen = function (n) { return '¥' + num(n); };
    var fill1 = function (tplAttr, fallback, amount) { return (sec.getAttribute(tplAttr) || fallback).split('{amount}').join(yen(amount)); };
    var paintGoals = function (st) {
      // reached goals: compact chips, kept as the record ("みんなでここまで達成した")
      var list = qs('[data-rf-cleared]', sec);
      if (list) {
        list.innerHTML = st.cleared.map(function (g) {
          // g.reward is always null for now; when rewards exist they are shown only for reached goals, here
          return '<li class="rf-chip" data-goal="' + g.index + '"><span class="rf-chip__check" aria-hidden="true">✓</span>' +
            esc(fill1('data-text-achieved', '{amount} 達成！', g.amount)) + '</li>';
        }).join('');
        list.hidden = !st.cleared.length;
        if (lastCleared !== null && st.cleared.length > lastCleared && list.lastElementChild) list.lastElementChild.classList.add('is-new');
      }
      // the goal being challenged now (FIRST GOAL / NEXT GOAL); nothing beyond it is ever put into the page
      var nextBox = qs('[data-rf-next]', sec), finalBox = qs('[data-rf-final]', sec);
      if (nextBox) nextBox.hidden = st.complete;
      if (finalBox) {
        finalBox.hidden = !st.complete;
        var ft = qs('[data-rf-final-text]', sec); if (ft) ft.textContent = st.complete ? fill1('data-text-final', '{amount} 達成！', st.cleared[st.cleared.length - 1].amount) : '';
      }
      var label = '';
      if (st.next) {
        label = st.next.first ? sec.getAttribute('data-label-first-goal') || 'FIRST GOAL' : sec.getAttribute('data-label-next-goal') || 'NEXT GOAL';
        var gl = qs('[data-rf-goal-label]', sec); if (gl) gl.textContent = label;
        var ge = qs('[data-rf-goal]', sec); if (ge) ge.textContent = num(st.next.amount);
        var rem = qs('[data-rf-remaining]', sec), remTpl = sec.getAttribute('data-text-remaining');
        if (rem) { rem.hidden = !remTpl; rem.textContent = remTpl ? fill1('data-text-remaining', '', st.next.amount - st.sales) : ''; }
      } else {
        var ge2 = qs('[data-rf-goal]', sec); if (ge2) ge2.textContent = '';
        var rem2 = qs('[data-rf-remaining]', sec); if (rem2) { rem2.hidden = true; rem2.textContent = ''; }
      }
      // big number: whole-festival rate against the FIRST GOAL (not capped)
      var pe = qs('[data-rf-pct]', sec); if (pe) pe.textContent = pctText(st.rate);
      // bar: progress to the goal being challenged now
      var fill = qs('[data-rf-fill]', sec); if (fill) fill.style.width = (st.sales > 0 ? Math.max(st.progress, 1.5) : 0) + '%';
      var bar = qs('[role="progressbar"]', sec);
      if (bar) { bar.setAttribute('aria-valuenow', st.progress.toFixed(1)); if (st.next) bar.setAttribute('aria-label', label + ' ' + yen(st.next.amount) + 'までの進捗'); }
      sec.setAttribute('data-goal-cleared', String(st.cleared.length));
      sec.setAttribute('data-goal-complete', st.complete ? 'true' : 'false');
      if (lastCleared !== st.cleared.length) {
        // for later UI (rewards etc.): only what is already public — reached goals and the current one
        try { sec.dispatchEvent(new CustomEvent('rf:stretch-goal', { bubbles: true, detail: { sales: st.sales, rate: st.rate, progress: st.progress, cleared: st.cleared, next: st.next, complete: st.complete } })); } catch (e) {}
      }
      lastCleared = st.cleared.length;
    };
    onSnapshot(function (snap) {
      var t = snap.totals || {};
      // snap.goal (the API's fixed goal) is intentionally not used: goals follow totals.sales.
      var st = stretchGoal(t.sales, goals);
      qsa('[data-rf-live-only]', sec).forEach(function (el) { el.hidden = false; });
      countUp(qs('[data-rf-sales]', sec), t.sales);
      countUp(qs('[data-rf-units]', sec), t.units);
      countUp(qs('[data-rf-participants]', sec), t.participants);
      paintGoals(st);
      if (upEl) upEl.textContent = updatedText(snap);
      // The API answered, but its aggregation has not moved for 10+ minutes during the event: say so.
      var at = Date.parse(snap.updated_at), now = PV.RF_PREVIEW_NOW || Date.now();
      if (!snap.demo && !isNaN(at) && now - at > 600000 && (isNaN(endAt) || at < endAt - 60000)) {
        sec.setAttribute('data-state', 'stale');
        if (statusEl) statusEl.textContent = sec.getAttribute('data-text-stale') || '';
      }
    });
  };

  /* ================= ④ RANKING ================= */
  var initRanking = function (sec) {
    var list = qs('[data-rf-list]', sec), moreBtn = qs('[data-rf-more]', sec);
    var base = Number(sec.getAttribute('data-count')) || 5, max = Number(sec.getAttribute('data-count-more')) || 15;
    var showMove = sec.getAttribute('data-show-move') === 'true';
    var current = 'all', expanded = false, snapRef = null, moreText = moreBtn ? moreBtn.innerHTML : '';
    var render = function () {
      if (!snapRef || !list) return;
      var all = (snapRef.ranking || {})[current] || [];
      var rows = all.slice(0, expanded ? max : base);
      if (moreBtn) moreBtn.parentNode.hidden = all.length <= base;
      if (!rows.length) { list.innerHTML = '<li class="rf-empty">' + esc(sec.getAttribute('data-empty') || '集計中です') + '</li>'; return; }
      var top = rows[0].units || 1;
      list.innerHTML = rows.map(function (r, i) {
        var c = colorOf(r.key), no = i + 1, move = '';
        if (showMove && isNum(r.prev_rank)) {
          var d = r.prev_rank - no;
          if (d >= 3) move = '<span class="rf-move rf-move--hot">急上昇</span>';
          else if (d > 0) move = '<span class="rf-move rf-move--up">↑' + d + '</span>';
          else if (d < 0) move = '<span class="rf-move rf-move--down">↓' + (-d) + '</span>';
        }
        var badge = no <= 3 ? '<span class="rf-rank__no rf-rank__no--' + no + '">' + ICON.crown + '<span>' + no + '位</span></span>'
          : '<span class="rf-rank__no"><span class="rf-rank__plain">' + no + '位</span></span>';
        var w = Math.max(6, Math.round((r.units || 0) / top * 100));
        return '<li class="rf-rank__item">' + badge + thumb(c, 'width:100%;aspect-ratio:1') +
          '<div><p class="rf-rank__name">' + esc(c.name) + '</p><div class="rf-rank__meter"><span style="width:' + w + '%;background:' + esc(c.color || '#e0a060') + '"></span></div></div>' +
          '<div class="rf-rank__units">' + num(r.units) + '<small>個</small>' + move + '</div></li>';
      }).join('');
    };
    qsa('[data-rf-tab]', sec).forEach(function (b) {
      b.addEventListener('click', function () {
        current = b.getAttribute('data-rf-tab');
        qsa('[data-rf-tab]', sec).forEach(function (x) { x.setAttribute('aria-selected', x === b ? 'true' : 'false'); });
        render();
      });
    });
    if (moreBtn) moreBtn.addEventListener('click', function () {
      expanded = !expanded;
      moreBtn.innerHTML = expanded ? esc(moreBtn.getAttribute('data-less') || '閉じる') : moreText;
      render();
    });
    onSnapshot(function (snap) {
      snapRef = snap;
      reveal(sec, !!(snap.ranking && snap.ranking.all && snap.ranking.all.length));
      render();
      var up = qs('[data-rf-updated]', sec); if (up) up.textContent = updatedText(snap);
    });
  };

  /* ================= ⑤ COMBOS ================= */
  var initCombos = function (sec) {
    var list = qs('[data-rf-list]', sec);
    var limit = Number(sec.getAttribute('data-count')) || 3, minBuyers = Number(sec.getAttribute('data-min')) || 1;
    var tpl = sec.getAttribute('data-buyers-text') || '人がこの組み合わせで購入';
    onSnapshot(function (snap) {
      var rows = (snap.combos || []).filter(function (r) { return r && r.keys && r.keys.length >= 2 && r.buyers >= minBuyers; }).slice(0, limit);
      reveal(sec, rows.length > 0);
      if (!list) return;
      if (!rows.length) { list.innerHTML = '<li class="rf-empty">' + esc(sec.getAttribute('data-empty') || '集計中です') + '</li>'; return; }
      list.innerHTML = rows.map(function (r, i) {
        var cs = r.keys.map(colorOf);
        return '<li class="rf-combo"><span class="rf-combo__no">' + (i + 1) + '</span><div class="rf-combo__imgs">' + cs.map(function (c) { return thumb(c); }).join('') + '</div>' +
          '<div><p class="rf-combo__names">' + cs.map(function (c, k) { return (k ? '×' : '') + fullName(c); }).join('<br>') + '</p>' +
          '<p class="rf-combo__buyers"><b>' + num(r.buyers) + '</b>' + esc(tpl) + '</p></div></li>';
      }).join('');
    });
  };

  /* ================= ⑥ LIVE FEED ================= */
  var ago = function (min) {
    min = Math.max(0, Math.round(Number(min) || 0));
    if (min < 60) return min + '分前';
    if (min < 180) return Math.floor(min / 60) + '時間前';
    return '本日';
  };
  var initFeed = function (sec) {
    var box = qs('[data-rf-list]', sec);
    var limit = Number(sec.getAttribute('data-count')) || 5;
    var tag = sec.getAttribute('data-tag') || '今、売れています！', suffix = sec.getAttribute('data-suffix') || 'に購入されました';
    onSnapshot(function (snap) {
      var rows = [];
      (snap.feed || []).forEach(function (r) { (r.items || []).forEach(function (it) { rows.push({ key: it.key, qty: it.qty, min: r.minutes_ago }); }); });
      rows = rows.slice(0, limit);
      reveal(sec, rows.length > 0);
      if (!box) return;
      if (!rows.length) { box.innerHTML = '<p class="rf-empty">' + esc(sec.getAttribute('data-empty') || 'まもなく表示されます') + '</p>'; return; }
      var line = function (r) { return ago(r.min) + esc(suffix); };
      var qty = function (r) { return r.qty > 1 ? ' ×' + num(r.qty) : ''; };
      var h = rows[0], hc = colorOf(h.key);
      var hero = '<a class="rf-feed__hero" href="' + esc(hc.url || '#rf-lineup') + '"><div class="rf-feed__hero-img' + (hc.cat === 'furoshiki' ? ' rf-cat-furoshiki' : '') + '">' + (hc.img ? '<img src="' + esc(hc.img) + '" alt="' + esc(hc.name) + '">' : '') + '</div>' +
        '<span class="rf-feed__tag">' + esc(tag) + '</span><div class="rf-feed__hero-bar">' + thumb(hc) +
        '<div style="flex:1;min-width:0"><p class="rf-feed__name">' + fullName(hc) + qty(h) + '</p><p class="rf-feed__time">' + line(h) + '</p></div>' + ICON.arrow + '</div></a>';
      var list = rows.slice(1).map(function (r) {
        var c = colorOf(r.key);
        return '<a class="rf-feed__row" href="' + esc(c.url || '#rf-lineup') + '">' + thumb(c) + '<div><p class="rf-feed__name">' + fullName(c) + '</p><p class="rf-feed__time">' + line(r) + '</p></div><span class="rf-feed__qty">' + qty(r) + '</span></a>';
      }).join('');
      box.innerHTML = hero + '<div class="rf-feed__list">' + list + '</div>';
    });
  };

  /* ================= ③ SECRET ================= */
  var paintSecret = function (sec, qty, required) {
    var box = qs('[data-rf-me]', sec); if (!box) return;
    var n = Math.max(0, Math.floor(qty)), left = required - n;
    qs('[data-rf-me-count]', box).innerHTML = num(n) + '<small>/ ' + num(required) + ' 個</small>';
    var fill = qs('[data-rf-me-fill]', box); if (fill) fill.style.width = Math.max(3, Math.min(100, n / required * 100)) + '%';
    qs('[data-rf-me-msg]', box).innerHTML = left > 0 ? 'あと<b>' + left + '個</b>で SECRET ORIBA を GET！' : 'おめでとうございます！ SECRET ORIBA の対象です';
    box.hidden = false;
    var gate = qs('[data-rf-me-gate]', sec); if (gate) gate.hidden = true;
  };
  var initSecret = function (sec) {
    var required = Number(sec.getAttribute('data-required')) || 10, url = sec.getAttribute('data-me-url');
    if (!qs('[data-rf-me]', sec)) return;
    if (config.demo && !PV.RF_PREVIEW_ME) { paintSecret(sec, 4, required); return; }
    if ((sec.getAttribute('data-logged-in') !== 'true' && !PV.RF_PREVIEW_ME) || !url) return;
    fetchMe(url).then(function (me) {
      var q = Number(me && me.purchased_qty);
      if (isFinite(q)) paintSecret(sec, q, Number(me.required_qty) || required);
    }).catch(function () {});
  };

  /* ================= ⑦ LINEUP ================= */
  var initLineup = function (sec) {
    var items = qsa('li[data-cat]', sec);
    qsa('[data-rf-filter]', sec).forEach(function (b) {
      b.addEventListener('click', function () {
        var f = b.getAttribute('data-rf-filter');
        qsa('[data-rf-filter]', sec).forEach(function (x) { x.setAttribute('aria-selected', x === b ? 'true' : 'false'); });
        items.forEach(function (it) { it.hidden = !(f === 'all' || it.getAttribute('data-cat') === f); });
      });
    });
    var sheet = qs('[data-rf-sheet]', sec);
    qsa('[data-rf-open]', sec).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var sizes = []; try { sizes = JSON.parse(btn.getAttribute('data-sizes') || '[]'); } catch (e) {}
        if (sizes.length === 1 || !sheet || typeof sheet.showModal !== 'function') { if (sizes[0]) location.href = sizes[0].url; return; }
        qs('[data-rf-sheet-name]', sheet).textContent = btn.getAttribute('data-name') || '';
        var img = btn.getAttribute('data-img');
        qs('[data-rf-sheet-img]', sheet).innerHTML = img ? '<img src="' + esc(img) + '" alt="">' : '';
        qs('[data-rf-sheet-list]', sheet).innerHTML = sizes.length ? sizes.map(function (s) {
          return '<li><a class="rf-sheet__link' + (s.available ? '' : ' is-soldout') + '" href="' + esc(s.url) + '">' + esc(s.label) +
            '<small>' + (s.available ? esc(s.price) : '完売') + '</small>' + ICON.arrow + '</a></li>';
        }).join('') : '<li class="rf-empty">現在お選びいただける商品がありません</li>';
        sheet.showModal();
      });
    });
    if (sheet) {
      qs('[data-rf-sheet-close]', sheet).addEventListener('click', function () { sheet.close(); });
      sheet.addEventListener('click', function (e) { if (e.target === sheet) sheet.close(); });
    }
  };

  /* ================= ⑧ LIVE ================= */
  var initLive = function (sec) {
    var lives = readJSON(sec.getAttribute('data-json-id')) || [];
    var defaultImg = sec.getAttribute('data-default-img') || '', defaultBubble = sec.getAttribute('data-default-bubble') || '';
    var fallbackMin = Number(sec.getAttribute('data-default-minutes')) || 60;
    var L = function (k, d) { return sec.getAttribute('data-l-' + k) || d; };
    lives = lives.map(function (l) {
      var s = parseJst(l.date, l.start), e = l.end ? parseJst(l.date, l.end) : s + fallbackMin * 60000;
      if (e <= s) e += 86400000;
      l.s = s; l.e = e; return l;
    }).filter(function (l) { return !isNaN(l.s); }).sort(function (a, b) { return a.s - b.s; });
    var card = qs('[data-rf-live-card]', sec), empty = qs('[data-rf-live-empty]', sec);
    if (!lives.length) { if (card) card.hidden = true; if (empty) empty.hidden = false; return; }
    var lastKey = '';
    every(20000, function () {
      var now = PV.RF_PREVIEW_NOW || Date.now(), today = jstDateKey(now);
      var todays = lives.filter(function (l) { return l.date === today; });
      var pick = todays.filter(function (l) { return now < l.e; })[0] || todays[todays.length - 1] ||
        lives.filter(function (l) { return l.s > now; })[0] || lives[lives.length - 1];
      var state = now < pick.s ? 'next' : now < pick.e ? 'now' : 'ended';
      var cdEl = qs('[data-rf-live-cd]', card);
      if (state === 'next' && cdEl) {
        var m = Math.max(0, Math.ceil((pick.s - now) / 60000));
        cdEl.textContent = '開始まで ' + (m >= 1440 ? Math.floor(m / 1440) + '日 ' : '') + (m >= 60 ? Math.floor(m % 1440 / 60) + '時間' : '') + (m % 60) + '分';
        cdEl.hidden = false;
      } else if (cdEl) cdEl.hidden = true;
      var key = pick.date + pick.start + state;
      if (key === lastKey) return;
      lastKey = key;
      var st = qs('[data-rf-live-state]', card);
      qs('span', st).textContent = state === 'now' ? L('now', 'LIVE NOW') : state === 'next' ? L('next', 'NEXT LIVE') : 'FINISHED';
      st.classList.toggle('is-now', state === 'now');
      qs('[data-rf-live-date]', card).textContent = dateLabel(pick.date);
      qs('[data-rf-live-time]', card).textContent = pick.start + ' START';
      qs('[data-rf-live-title]', card).textContent = pick.title || '';
      qs('[data-rf-live-desc]', card).textContent = state === 'ended' ? L('ended', '本日のライブは終了しました') : (pick.desc || '');
      var bub = qs('[data-rf-live-bubble]', card), btxt = pick.bubble || defaultBubble;
      if (bub) { bub.textContent = btxt; bub.hidden = !btxt || state === 'ended'; }
      var img = qs('[data-rf-live-img]', card), src = pick.img || defaultImg;
      if (img) { if (src) { img.src = src; img.hidden = false; } else img.hidden = true; }
      var cta = qs('[data-rf-live-cta]', card), btn = '';
      if (state === 'now' && pick.url) btn = '<a class="rf-btn rf-btn--live" href="' + esc(pick.url) + '" target="_blank" rel="noopener">' + esc(L('watch', 'ライブを視聴する')) + ICON.arrow + '</a>';
      else if (state === 'next' && pick.url) btn = '<a class="rf-btn rf-btn--light" href="' + esc(pick.url) + '" target="_blank" rel="noopener">' + esc(L('soon', '配信ページを開く')) + ICON.arrow + '</a>';
      else if (state === 'ended' && pick.archive) btn = '<a class="rf-btn rf-btn--light" href="' + esc(pick.archive) + '" target="_blank" rel="noopener">' + esc(L('archive', 'アーカイブを見る')) + ICON.arrow + '</a>';
      cta.innerHTML = btn; cta.hidden = !btn;
      var nextBox = qs('[data-rf-live-next]', card);
      var upcoming = lives.filter(function (l) { return l.s > Math.max(now, pick.s); }).slice(0, 3);
      if (nextBox) {
        nextBox.hidden = !upcoming.length;
        qs('ul', nextBox).innerHTML = upcoming.map(function (l) { return '<li><b>' + esc(dateLabel(l.date)) + ' ' + esc(l.start) + '</b><span>' + esc(l.title || '') + '</span></li>'; }).join('');
      }
      card.hidden = false; if (empty) empty.hidden = true;
    });
  };

  /* ================= ⑨ STAMP ================= */
  var initStamp = function (sec) {
    var cells = qsa('[data-day]', sec), strip = qs('[data-rf-stamp-strip]', sec);
    var startMs = parseJst(sec.getAttribute('data-start-date'), '00:00');
    var now = PV.RF_PREVIEW_NOW || Date.now();
    var todayNo = isNaN(startMs) ? 0 : Math.floor((now - startMs) / 86400000) + 1;
    cells.forEach(function (c) { if (Number(c.getAttribute('data-day')) === todayNo) c.classList.add('is-today'); });
    var todayCell = qs('.is-today', sec);
    if (todayCell && strip && strip.scrollWidth > strip.clientWidth) {
      var sr = strip.getBoundingClientRect(), cr = todayCell.getBoundingClientRect();
      if (cr.right > sr.right - 8) strip.scrollLeft += cr.right - sr.right + cr.width * 2;
    }
    var countEl = qs('[data-rf-stamp-count]', sec), got = {};
    var paint = function (list, fresh) {
      (list || []).forEach(function (d) { got[d] = true; });
      cells.forEach(function (c) {
        var d = Number(c.getAttribute('data-day'));
        if (got[d]) { c.classList.add('is-got'); c.setAttribute('aria-label', 'DAY' + pad(d) + ' 取得済み'); }
        if (fresh && d === fresh) c.classList.add('is-new');
      });
      if (countEl) countEl.textContent = Object.keys(got).length;
    };
    var open = sec.getAttribute('data-open') === 'true', loggedIn = sec.getAttribute('data-logged-in') === 'true';
    var base = (sec.getAttribute('data-api') || '').replace(/\/$/, '');
    var form = qs('[data-rf-stamp-form]', sec), msg = qs('[data-rf-stamp-msg]', sec);
    var join = qs('[data-rf-stamp-join]', sec), joinWrap = qs('[data-rf-stamp-join-wrap]', sec);
    var gateLogin = qs('[data-rf-gate-login]', sec), gateClosed = qs('[data-rf-gate-closed]', sec);
    var showPanel = function () {
      if (joinWrap) joinWrap.hidden = true;
      if (PV.RF_PREVIEW_ME || config.demo) { form.hidden = false; return; }
      if (!open || !base) { if (gateClosed) gateClosed.hidden = false; return; }
      if (!loggedIn) { if (gateLogin) gateLogin.hidden = false; return; }
      form.hidden = false; qs('input', form).focus();
    };
    if (join) join.addEventListener('click', showPanel);
    var csrf = '';
    if (config.demo && !PV.RF_PREVIEW_ME) paint([1, 2, 3, 4]);
    else if (PV.RF_PREVIEW_ME || (open && base && loggedIn)) {
      fetchMe(base + '/me').then(function (me) { csrf = (me && me.csrf) || ''; paint(me && me.stamps); })
        .catch(function () { if (msg) { msg.textContent = '読み込みに失敗しました。時間をおいて再度お試しください。'; msg.className = 'rf-stamp__msg is-ng'; } });
    }
    var ERR = { invalid: '合言葉が違うようです。もう一度お確かめください。', already: 'このスタンプはすでにGET済みです。', not_open: 'この合言葉はまだ受付前です。',
      expired: 'この合言葉の受付期間は終了しました。', rate_limited: '入力回数が上限に達しました。しばらくしてからお試しください。', login_required: 'ログインが必要です。' };
    if (form) form.addEventListener('submit', function (ev) {
      ev.preventDefault();
      var input = qs('input', form), btn = qs('button', form), kw = (input.value || '').trim();
      if (!kw) return;
      btn.disabled = true;
      var done = function (res) {
        if (res && res.ok) {
          paint([res.day], res.day);
          msg.textContent = 'DAY' + pad(res.day) + ' のスタンプをGETしました！'; msg.className = 'rf-stamp__msg is-ok'; input.value = '';
          if (res.csrf) csrf = res.csrf;
        } else { msg.textContent = ERR[res && res.error] || '送信できませんでした。時間をおいて再度お試しください。'; msg.className = 'rf-stamp__msg is-ng'; }
        btn.disabled = false;
      };
      if (PV.RF_PREVIEW_STAMP) { done(PV.RF_PREVIEW_STAMP(kw)); return; }
      fetch(withEvent(base + '/stamps'), {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-RF-Requested': '1' },
        body: JSON.stringify({ keyword: kw, csrf: csrf })
      }).then(function (r) { return r.json().catch(function () { return { ok: false }; }); })
        .then(done).catch(function () { done({ ok: false, error: 'network' }); });
    });
  };

  /* ================= ⑩ GOALS ================= */
  var initGoals = function (sec) {
    var list = qs('[data-rf-list]', sec); if (!list) return;
    var items = qsa('[data-amount]', list).sort(function (a, b) { return Number(a.getAttribute('data-amount')) - Number(b.getAttribute('data-amount')); });
    items.forEach(function (li) { list.appendChild(li); });
    var dotsBox = qs('[data-rf-track-dots]', sec), fill = qs('[data-rf-track-fill]', sec);
    var n = items.length, pos = function (i) { return n <= 1 ? 50 : (i / (n - 1)) * 96 + 2; };
    if (dotsBox) dotsBox.innerHTML = items.map(function (_, i) { return '<span class="rf-track__dot" style="left:' + pos(i) + '%"></span>'; }).join('');
    var paint = function (sales) {
      var currentSet = false, prev = 0, progress = 0;
      items.forEach(function (li, i) {
        var amt = Number(li.getAttribute('data-amount')) || 0, forced = li.getAttribute('data-force') === 'true';
        var reached = forced || (isNum(sales) && sales >= amt);
        var state = reached ? 'reached' : !currentSet ? 'current' : 'locked';
        if (state === 'current') {
          currentSet = true;
          var ratio = isNum(sales) ? Math.max(0, Math.min(1, (sales - prev) / Math.max(1, amt - prev))) : 0;
          progress = i === 0 ? pos(0) * ratio : pos(i - 1) + (pos(i) - pos(i - 1)) * ratio;
        }
        if (reached) { prev = amt; progress = pos(i); }
        li.classList.remove('is-reached', 'is-current', 'is-locked'); li.classList.add('is-' + state);
        var st = qs('[data-rf-goal-state]', li), label = li.getAttribute('data-l-' + state) || '';
        if (st) { st.textContent = label; st.hidden = !label; }
        var locked = state === 'locked' && li.getAttribute('data-reveal') !== 'true';
        qsa('[data-rf-goal-secret]', li).forEach(function (el) { el.hidden = locked; });
        qsa('[data-rf-goal-mask]', li).forEach(function (el) { el.hidden = !locked; });
        var dot = dotsBox && dotsBox.children[i]; if (dot) dot.classList.toggle('is-on', reached || state === 'current');
      });
      if (fill) fill.style.width = progress + '%';
      var cur = qs('.is-current', list);
      if (cur && list.scrollWidth > list.clientWidth) {
        var lr = list.getBoundingClientRect(), cr = cur.getBoundingClientRect();
        if (cr.right > lr.right) list.scrollLeft += cr.right - lr.right + 4;
      }
    };
    paint(null);
    onSnapshot(function (snap) { paint(snap.totals && snap.totals.sales); });
  };

  /* ---------------- boot ---------------- */
  var inits = { record: initRecord, ranking: initRanking, combos: initCombos, feed: initFeed, secret: initSecret, lineup: initLineup, live: initLive, stamp: initStamp, goals: initGoals };
  var boot = function (scope) {
    qsa('[data-rf]', scope).forEach(function (sec) {
      if (sec.__rfDone) return;
      sec.__rfDone = true;
      var fn = inits[sec.getAttribute('data-rf')];
      if (fn) { try { fn(sec); } catch (e) { if (window.console) console.warn('[rf]', e); } }
    });
  };
  var formatYen = function (scope) {
    qsa('[data-rf-yen]', scope).forEach(function (el) { var v = Number(el.textContent.replace(/[^0-9.-]/g, '')); if (isFinite(v)) el.textContent = num(v); });
  };
  var go = function () { formatYen(document); boot(document); startSnapshot(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', go); else go();
  document.addEventListener('shopify:section:load', function (e) { formatYen(e.target); boot(e.target); });
})();
